// quality_selector.js
export const getQualitySelector = (Clappr) => {

  // === Пороги макс. высоты по ширине плеера ===
  function getMaxHeightByWidth(width) {
    if (width < 500) return 360;
    if (width < 700) return 480;
    if (width < 900) return 640;
    if (width < 1100) return 720;
    if (width < 1600) return 1080;
    if (width < 1910) return 1440;
    return 2160;
  }

  // === Утилита троттла для ресайза ===
  function throttle(fn, wait) {
    let last = 0, timer = null;
    return function throttled(...args) {
      const now = Date.now();
      const remaining = wait - (now - last);
      if (remaining <= 0) {
        clearTimeout(timer); timer = null; last = now; fn.apply(this, args);
      } else if (!timer) {
        timer = setTimeout(() => { last = Date.now(); timer = null; fn.apply(this, args); }, remaining);
      }
    };
  }

  //QualitySelector
  const QualitySelector = Clappr.UICorePlugin.extend({
    name: 'quality_selector',
    version: '2.0',

    bindEvents: function () {
      this.listenTo(this.core, Clappr.Events.CORE_READY, this.bindPlaybackEvents);
      this.listenTo(this.core, Clappr.Events.CORE_ACTIVE_CONTAINER_CHANGED, this.reload);
      this.listenTo(this.core.mediaControl, Clappr.Events.MEDIACONTROL_RENDERED, this.render);
      this.listenTo(this.core.mediaControl, Clappr.Events.MEDIACONTROL_HIDE, this.hideSelectLevelMenu);
    //  this.listenTo(this.core.mediaControl, Clappr.Events.MEDIACONTROL_SHOW, this.showHDIcon);
    this.HDChecked = false

      // ресайз-наблюдатель
      this.setupResizeWatcher();
    },

    unBindEvents: function () {
      var currentPlayback = this.core.activePlayback;

      this.stopListening(this.core, Clappr.Events.CORE_READY);
      this.stopListening(this.core, Clappr.Events.CORE_ACTIVE_CONTAINER_CHANGED);
      this.stopListening(this.core.mediaControl, Clappr.Events.MEDIACONTROL_RENDERED);
      this.stopListening(this.core.mediaControl, Clappr.Events.MEDIACONTROL_HIDE);
      this.stopListening(this.core.mediaControl, Clappr.Events.MEDIACONTROL_SHOW);

      // снять наблюдателей ресайза
      this.teardownResizeWatcher();

      if (!currentPlayback) return;
      this.stopListening(currentPlayback, Clappr.Events.PLAYBACK_LEVELS_AVAILABLE);
      this.stopListening(currentPlayback, Clappr.Events.PLAYBACK_LEVEL_SWITCH_START);
      this.stopListening(currentPlayback, Clappr.Events.PLAYBACK_LEVEL_SWITCH_END);
      this.stopListening(currentPlayback, Clappr.Events.PLAYBACK_BITRATE);
      this.stopListening(currentPlayback, Clappr.Events.PLAYBACK_STOP);
      this.stopListening(currentPlayback, Clappr.Events.PLAYBACK_PLAY_INTENT);
    },

    bindPlaybackEvents: function () {
      var currentPlayback = this.core.activePlayback;

      this.listenTo(currentPlayback, Clappr.Events.PLAYBACK_LEVELS_AVAILABLE, this.fillLevels);
      this.listenTo(currentPlayback, Clappr.Events.PLAYBACK_LEVEL_SWITCH_START, this.startLevelSwitch);
      this.listenTo(currentPlayback, Clappr.Events.PLAYBACK_LEVEL_SWITCH_END, this.stopLevelSwitch);
      this.listenTo(currentPlayback, Clappr.Events.PLAYBACK_BITRATE, this.updateCurrentLevel);
      this.listenTo(currentPlayback, Clappr.Events.PLAYBACK_PLAY_INTENT, this.playbackIntent);
      this.listenTo(currentPlayback, Clappr.Events.PLAYBACK_STOP, this.playbackStop);

      var playbackLevelsAvaialbeWasTriggered = currentPlayback.levels && currentPlayback.levels.length > 0;
      if (playbackLevelsAvaialbeWasTriggered) this.fillLevels(currentPlayback.levels);
    },

    reload: function () {
      this.unBindEvents();
      this.bindEvents();
      this.bindPlaybackEvents();
      this.applyAutoCap(); // актуализировать кап после смены контейнера
    },

    shouldRender: function () {
      if (!this.core.activeContainer) return false;
      var currentPlayback = this.core.activePlayback;
      if (!currentPlayback) return false;

      var respondsToCurrentLevel = currentPlayback.currentLevel !== undefined;
      var hasLevels = !!(this.levels && this.levels.length > 1);

      return respondsToCurrentLevel && hasLevels;
    },

    render: function () {
      if (this.shouldRender()) {
        var style = this.pluginStyle;
        this.$el.html(this.template(this.levels, this.getTitle()));
        if (style) this.$el.append(style);
        this.core.mediaControl.$('.media-control-right-panel').append(this.el);
        this.highlightCurrentLevel();
      }
      return this;
    },

    template: function (levels, title) {
      var template = ' <style>.media-control-icon[data-hd-indicator]{ display:none !important;}</style>  <button data-quality-selector-button>Auto</button><ul>';
      if (title) template += '<li data-title>' + title + '</li>';
      for (var i = levels.length - 1; i > -1; i--) {
        template += '<li><a href="#" data-quality-selector-select="' + levels[i].id + '">' + levels[i].label + '</a></li>';
      }
      template += '<li><a href="#" data-quality-selector-select="-1">AUTO</a></li>';
      return template;
    },

    showHDIcon: function () {
   
      return
      if (this.HDChecked) return;
 
      this.HDChecked = true;
      var levels = this.core.activePlayback._hls.levels;
      for (var i = 0; i < levels.length; i++) {
        if (levels[i].height >= 11720 || (levels[i].bitrate / 1000) >= 1112000) {
          $(this._options.parentId).addClass('showHDIcon');
          break;
        }
      }
    },

    playbackIntent: function () {
      if (!this.FIRST_START) return;
      this.FIRST_START = false;
      this.DEFAULT_QUALITY = parseInt(localStorage.getItem('savedLevelId'));
      var defaultQuality = this.DEFAULT_QUALITY;
      if (isNaN(defaultQuality)) {
        var qsConfig = this._options.qualitySelectorConfig;
        if (qsConfig && !isNaN(qsConfig.defaultQuality))
          defaultQuality = qsConfig.defaultQuality;
      }

      if (!isNaN(defaultQuality)) {
        this.core.activePlayback.currentLevel = this.selectedLevelId = defaultQuality;
      }

      // при старте сразу применить автокап (если AUTO)
      this.applyAutoCap();
    },

    playbackStop: function () {
      this.FIRST_START = true;
    },

    fillLevels: function (levels, initialLevel) {
      if (this.selectedLevelId === undefined)
        this.selectedLevelId = initialLevel ? initialLevel : -1;

      // метки по высоте (разные форматы level возможны)
      levels = levels.map(level => {
        const h = (level && level.level && level.level.height) || level.height;
        level.label = (h ? h : 'AUTO') + 'p';
        return level;
      });

      this.levels = levels;
      this.configureLevelsLabels();

      // пересчитать кап после появления уровней
      this.applyAutoCap();

      this.render();
    },

    configureLevelsLabels: function () {
      if (this.core.options.qualitySelectorConfig === undefined) return;

      var labelCallback = this.core.options.qualitySelectorConfig.labelCallback;
      if (labelCallback && typeof labelCallback !== 'function')
        throw new TypeError('labelCallback must be a function');

      var hasLabels = this.core.options.qualitySelectorConfig.labels;
      var labels = hasLabels ? this.core.options.qualitySelectorConfig.labels : {};

      if (labelCallback || hasLabels) {
        // BUGFIX: было this.levels; должно быть this.levels.length
        for (var i = 0; i < this.levels.length; i++) {
          var level = this.levels[i];
          var label = labels[level.id];
          if (labelCallback)
            level.label = labelCallback(level, label);
          else if (label)
            level.label = label;
        }
      }
    },

    onLevelSelect: function (event) {
      this.selectedLevelId = parseInt(event.target.dataset.qualitySelectorSelect, 10);
      var hls = this.core.activePlayback._hls;

      if (this.selectedLevelId === -1) {
        // AUTO: включаем автокап и отдаём выбор hls.js
        this.applyAutoCap();
        hls.nextLevel = -1;
      } else {
        if (hls.nextLevel == this.selectedLevelId) return false;
        // ручной выбор: снять кап, чтобы уважить выбор
        hls.autoLevelCapping = undefined;
        hls.nextLevel = this.selectedLevelId;
      }

      localStorage.setItem('savedLevelId', this.selectedLevelId);
      this.toggleContextMenu();
      event.stopPropagation();
      return false;
    },

    onShowLevelSelectMenu: function () { this.toggleContextMenu(); },

    hideSelectLevelMenu: function () { this.$('.quality_selector ul').hide(); },

    toggleContextMenu: function () { this.$('.quality_selector ul').toggle(); },

    buttonElement: function () { return this.$('.quality_selector button'); },

    levelElement: function (id) { return this.$('.quality_selector ul a' + (!isNaN(id) ? '[data-quality-selector-select="' + id + '"]' : '')).parent(); },

    getTitle: function () { return (this.core.options.qualitySelectorConfig || {}).title; },

    startLevelSwitch: function () { this.buttonElement().addClass('changing'); },

    stopLevelSwitch: function () { this.buttonElement().removeClass('changing'); },

    findLevelBy: function (id) {
      var foundLevel;
      this.levels.forEach(function (level) { if (level.id === id) foundLevel = level; });
      return foundLevel;
    },

    updateText: function (level) {
      if (level === -1) {
        this.buttonElement().text(  'AUTO');
      } else {
        try {
          this.buttonElement().text(this.findLevelBy(level).label);
        }
        catch (ex) {
          localStorage.setItem('savedLevelId', '-1');
          var currentPlayback = this.core.activePlayback;
          currentPlayback.currentLevel = -1;
          currentPlayback.trigger(Clappr.Events.PLAYBACK_LEVEL_SWITCH_END);
          this.updateText(-1);
        }
      }
    },

    updateCurrentLevel: function (info) {
      var level = this.findLevelBy(info.level);
      this.currentLevel = level ? level : null;
      this.highlightCurrentLevel();
    },

    highlightCurrentLevel: function () {
      this.levelElement().removeClass('current');
      if (this.currentLevel) this.levelElement(this.currentLevel.id).addClass('current');
      this.updateText(this.selectedLevelId);
    },

    // === ABR cap helpers ===
    getPlayerWidth: function () {
      const container = this.core.activeContainer && this.core.activeContainer.el;
      const root = this.core && this.core.el;
      return (container && container.clientWidth) || (root && root.clientWidth) || (this.$el && this.$el.width()) || 0;
    },

    getLevelHeight: function (lvl) {
      return (lvl && lvl.height) || (lvl && lvl.level && lvl.level.height) || null;
    },

    computeAutoCapLevelIndex: function () {
      const hls = this.core.activePlayback && this.core.activePlayback._hls;
      if (!hls || !hls.levels || !hls.levels.length) return undefined;

      const playerW = this.getPlayerWidth();
      const maxH = getMaxHeightByWidth(playerW);

      let bestIndex = undefined;
      for (let i = 0; i < hls.levels.length; i++) {
        const h = this.getLevelHeight(hls.levels[i]);
        if (!h) continue;
        if (h <= maxH) {
          if (bestIndex === undefined) bestIndex = i;
          else {
            const bestH = this.getLevelHeight(hls.levels[bestIndex]) || 0;
            if (h >= bestH) bestIndex = i;
          }
        }
      }
      if (bestIndex === undefined) bestIndex = 0; // если все уровни выше потолка — взять самый низкий
      return bestIndex;
    },

    applyAutoCap: function () {
      if (this.selectedLevelId !== -1) return; // только в AUTO

      const hls = this.core.activePlayback && this.core.activePlayback._hls;
      if (!hls) return;

      const capIndex = this.computeAutoCapLevelIndex();
      if (capIndex === undefined) return;

      if (hls.autoLevelCapping !== capIndex) {
        hls.autoLevelCapping = capIndex;
        hls.nextLevel = -1; // позволить hls.js выбрать лучший внутри капа
      }

      this.updateText(-1);
    },

    // === Resize watching ===
    setupResizeWatcher: function () {
      this.teardownResizeWatcher();
      const containerEl = this.core && this.core.activeContainer && this.core.activeContainer.el;
      const rootEl = this.core && this.core.el;

      const onResize = throttle(() => {
        if (this.selectedLevelId === -1) this.applyAutoCap();
      }, 200);

      if (typeof ResizeObserver !== 'undefined' && (containerEl || rootEl)) {
        this._resizeObserver = new ResizeObserver(onResize);
        if (containerEl) this._resizeObserver.observe(containerEl);
        if (rootEl && rootEl !== containerEl) this._resizeObserver.observe(rootEl);
      } else {
        this._onWindowResize = onResize;
        window.addEventListener('resize', this._onWindowResize);
      }
    },

    teardownResizeWatcher: function () {
      if (this._resizeObserver) {
        try { this._resizeObserver.disconnect(); } catch(_) {}
        this._resizeObserver = null;
      }
      if (this._onWindowResize) {
        window.removeEventListener('resize', this._onWindowResize);
        this._onWindowResize = null;
      }
    },

    //pluginStyle: '<style></style>',

    attributes: {
      'class': 'quality_selector',
      'data-quality-selector': ''
    },

    events: {
      'click [data-quality-selector-select]': 'onLevelSelect',
      'click [data-quality-selector-button]': 'onShowLevelSelectMenu'
    },

    DEFAULT_QUALITY: parseInt(localStorage.getItem('savedLevelId')),
    FIRST_START: true,
    HDChecked: false,
  });

  Object.defineProperty(QualitySelector, 'name', { value: 'QualitySelector' });

  // helpers на прототип плеера
  Clappr.Player.prototype.setPlaybackQuality = function (id) {
    var qs = this.getPlugin('quality_selector');
    if (qs && qs.levels && id <= qs.levels.length - 1) {
      qs.selectedLevelId = this.core.activePlayback.currentLevel = id;
      const hls = this.core.activePlayback && this.core.activePlayback._hls;
      if (hls) hls.autoLevelCapping = undefined; // ручной выбор — без капа
      qs.updateCurrentLevel({ level: id });
    }
  };

  Clappr.Player.prototype.getPlaybackQuality = function () {
    return this.getPlugin('hls').levels;
  };

  return QualitySelector;
};